module.exports = require('./helpers/bundle-url').getBundleURL('hdhZv') + "oak-haven-timber-balmoral-1.bb40fa52.jpg";